import AExperimentsClient from 'app/common/lib/ExperimentsClient/AExperimentsClient';
import QueuedResourceCall from 'app/common/lib/ResourceFactory/QueuedResourceCall';
import ResourceFactory from 'app/common/lib/ResourceFactory';

/**
 * A stateful object for testing whether an experiment is active.
 * The state of each experiment is tracked, and when an experiment transitions
 * from "triggerable" to "active", we report home that the transition occurred.
 */
export default class ExperimentsClient extends AExperimentsClient {
  /**
   * @override
   */
  v2ActivateExperiment(name) {
    return this._getGroupForExperiment(name, true);
  }

  flush() {
    if (this._queuedResource) {
      this._queuedResource.flush();
    }
  }
  /**
   * V2 API. This should only be used with V2 experiments.
   * Logs a user into an override group, but does NOT set the group to active
   * Use v2_activate_experiment if you want to trigger based on the config/triggerable.
   * @param {string} name
   * @param {string} overrideGroup
   * @param {boolean} isSeoExp
   * @override
   */
  v2LogExperimentGroupOverride(name, overrideGroup, isSeoExp) {
    this._reportExperimentActivated(name, false, overrideGroup, overrideGroup, isSeoExp);
  }

  _getGroupForExperiment(name, activate, add_to_experiment) {
    if (activate === undefined) {
      activate = true;
    }
    let group = this.active[name];
    // If the experiment isn't already active, test whether it's triggerable.
    if (group === undefined && activate) {
      group = this.triggerable[name];
      // If the experiment is triggerable, make it active and report
      // home that we activated it.
      if (group !== undefined) {
        this.active[name] = group;
        this._reportExperimentActivated(name, add_to_experiment, group);
      }
    }
    return group || null;
  }

  _reportExperimentActivated(name, add_to_experiment, experimentGroup, overrideGroup, isSeoExp) {
    const resourceDict = {
      add_to_experiment: !!add_to_experiment,
      experiment_name: name,
      is_seo_exp: !!isSeoExp,
    };

    if (overrideGroup) {
      resourceDict.override_group = overrideGroup;
    }

    if (experimentGroup) {
      resourceDict.experiment_group = experimentGroup;
    }

    if (this.useBatching) {
      if (!this._queuedResource) {
        this._queuedResource = new QueuedResourceCall('ActivateExperimentResource', (queue) => ({
          experiments: queue,
        }));
      }
      this._queuedResource.enqueue(resourceDict);
    } else {
      const resource = ResourceFactory.create('ActivateExperimentResource', resourceDict);
      resource.callCreate({ showError: false });
    }
  }
}
